// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8430) return "static/chunks/147b5626-4740743c82844e23.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2223 ? "1dd6ffb7" : chunkId) + "." + {"2223":"f2d5ae4576342ae2","3914":"74e0c4d80077805f","9865":"fac2101a06b84b6c"}[chunkId] + ".js";
};